// removed by extract-text-webpack-plugin
module.exports = {"footer":"_1Sdj-gTSvDsgjGdqb2Nbxr","transferTable":"_2AmwgFfKWfWiM5Q1NA5xQx","thHeader":"_3MihUTf3ChzERW5awanYvC","thCurrency":"_2m7BjGiDRggJf6zRof8Wki","tdWithErrorMessages":"_1bIukU2iBBVE0Bw3WJLve","validationErrorsBox":"_9FX1vRy84YK2H6oDcixpw","transferMaxButton":"NixinVPBgep12w1NOkTxa"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TokenTransferForm.scss
// module id = 1284
// module chunks = 0